<template>
  <div v-if="noSideBar" class="row full-width">
    <div style="width: 100%">
      <div class="q-pa-none">
        <div class="row full-width">
          <div style="width: 100%">
            <topbar :backgroundColor="headerBackgroundColor">
              <template v-slot:content>
                <slot name="headerContent"></slot>
              </template>
            </topbar>
          </div>
        </div>
      </div>
      <div>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
  <div v-else class="row full-width">
    <div style="width: 75%">
      <div class="q-pa-none">
        <div class="row full-width">
          <div style="width: 100%">
            <topbar :backgroundColor="headerBackgroundColor">
              <template v-slot:content>
                <slot name="headerContent"></slot>
              </template>
            </topbar>
          </div>
        </div>
      </div>
      <div>
        <slot name="content"></slot>
      </div>
    </div>
    <div style="width: 25%; height: calc(100vh - 60px)" class="bg-grey-2">
      <slot name="sideBarContent"></slot>
    </div>
  </div>
</template>

<script>
  import Topbar from "@/components/topbar/topbar.vue";
  import SideBar from "@/components/sidebar/sidebar.vue";
  export default {
    components: {
      Topbar,
      SideBar,
    },
    props: {
      headerPadding: {
        type: String,
        default: "q-pa-md",
      },
      headerBackgroundColor: {
        type: String,
        default: "#162c47",
      },
      noSideBar: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
